import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const CloseX = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g fill={props.fill || '#000'} fillRule="nonzero">
        <path d="M20 .875L19.125 0 10 9.125.875 0 0 .875 9.125 10 0 19.125.875 20 10 10.875 19.125 20l.875-.875L10.875 10z"></path>
      </g>
    </g>
  </SvgIcon>
);

export default CloseX;
